{
  "en": {
    "profile": {
      "actions": {
        "changeEmail": "Change email address",
        "changeEmailAddress": "Change email address",
        "delete": "Delete",
        "installApp": "Install app 🚀",
        "launchApp": "Launch app",
        "save": "Save",
        "showQRCode": "Show QR Code"
      },
      "attributes": {
        "decimal_separator": "Decimal currency notation",
        "email_address": "Email",
        "email_address_new": "New email address",
        "email_address_old": "Old email address"
      },
      "labels": {
        "addToHomeScreen": "Add to home screen",
        "allowAccess": "Give Ziggu access to your account",
        "allowImpersonation": "Allow Ziggu access",
        "allowImpersonationSubtext": "We may need to temporarily access your account to diagnose and resolve a customer support issue you’ve raised. Our access automatically expires after 7 days.",
        "allowRecording": "Allow session recording",
        "allowRecordingSubtext": "Recording your session in Ziggu might help us to find the root cause of an issue you've raised. The recording stops automatically after 60 minutes or whenever you disable this setting.",
        "and_x_other": "and 1 other | and {other_count} others",
        "bulk_invite_help": "We'll invite the selected contacts to the platform. This can take a few minutes.",
        "changeEmailAddress": "Change email address for {profile_name}",
        "checkYourInbox": "We sent an email to {email_address} to confirm",
        "confirmEmailUpdate": "The email contains a link to complete the update process. Contact us if you experience any problems.",
        "confirmPasswordReset": "An email has been sent with a link to reset your password, please check your inbox. Contact us if you experience any problems.",
        "currency": {
          "comma": "Comma: 200.450,99",
          "point": "Point: 200,450.99"
        },
        "delete_info": "Are you sure you want to delete this user? This action will remove all the sensitive user data and will block the user from logging in and getting emails any longer",
        "delete_user": "Delete {user_name}",
        "emailAddressNewConfirm": "Confirm new email address",
        "emailNotificationsInterval": "Email frequency for new notifications",
        "emailNotificationsIntervalSubtext": "Here you can set how often you would like the platform to check if there are any updates for you and send you an email about it.",
        "explainerSendEmail": "A new invitation email will be sent to {name}",
        "explainerUpdateEmailActive": "{name} is already active on the platform. An email will be sent to the new email address with a link to confirm the email address change.",
        "explainerUpdateEmailInvited": "{name} has been invited already. A new invitation will be sent to the new email address. Any previous invitations will be non-functional.",
        "followDevicePrompts": "Follow your device's prompts to add the app to your home screen",
        "impersonateProfile": "Impersonate {profile_name}",
        "important": "Important",
        "importantContent": "Make sure you are logged in on the platform on your mobile device via the web browser.",
        "installMobileApp": "Install Mobile App",
        "logInMobileDevice": "Log in on your mobile device",
        "maintainerCannotImpersonatePartner": "Only team members with the 'Owner' role can impersonate partners.",
        "maintainerCannotUpdateEmailAddress": "Only team members with 'Owner' role can update the email address",
        "multipleProfiles": "This user has multiple Ziggu profiles. Only the user can change the email address.",
        "mustBeLoggedInBeforeQR": "You must be logged in on your mobile device before scanning the QR code",
        "noEmailAddressAdded": "No email address added",
        "onceLoggedInScan": "Once logged in, scan the QR code to install the app on your device",
        "openMobileBrowser": "Open your mobile browser and visit",
        "public_api_access": "Public API access token",
        "redirectAutomatically": "You will be redirected automatically in {seconds} seconds",
        "requestPasswordReset": "Reset password",
        "scanQRCode": "Scan the QR code",
        "toLogInCredentials": "to log in with your credentials",
        "updateEmailFailed": "Your email address failed to update. Please retry or contact us.",
        "updateEmailSuccessful": "Your email address has been updated successfully",
        "updateFailed": "Update failed. Please retry or contact us.",
        "writeProfileNameReject": "Write <i><b>{profile_name}</b></i> to continue."
      },
      "notifications": {
        "avatarChangedSuccessfully": "The avatar has been updated. The changes could take up to one hour to be visible."
      },
      "toasts": {
        "bulk_invite": "We've started inviting the selected contacts to the platform",
        "emailResendSuccessfully": "Email resend successfully"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "The email address either does not exist, or no longer exists, please change the email address.",
          "illegal_address": "Illegal email address: the email address you’re providing may not be set up correctly, please ensure the email address is properly formatted and does not contain any illegal characters.",
          "isp_block": "ISP-block: a block usually means that our IP address or server was rejected from the receiving mail server.",
          "soft_bounce": "The person is out of the office, or the mailbox is full and not accepting emails.",
          "spam_complaint": "The person clicked the \"Mark as Spam\" in their email client, this email address has been deactivated. If the recipient reaches out to you and wants to receive emails again, contact us.",
          "spam_notification": "Emails were rejected by the mail server. This could be due to rigid corporate policies in place on the receiving mail server or some bad choice of words in your email that are getting flagged by spam filters."
        },
        "emailAddressBounced": "Email address error",
        "emailDoesntMatch": "Email does not match",
        "emailTaken": "Email address is already taken. If you would like to make this change anyways, please contact us via the chat.",
        "mustBeEmailAddress": "Valid email address required",
        "requireEmailAddress": "Email required",
        "tooManyRequests": "Only one email address change allowed every 5 minutes. Try again later."
      }
    }
  }
}
